import FilterAltOutlinedIcon from '@mui/icons-material/FilterAltOutlined';
import { Box, useTheme } from "@mui/material";
import cx from 'classnames';
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import Text from "../../../../theme/text/Text";
import { tokens } from "../../../../../theme";
import { reportFilterDataSource } from '../../chartFilterEnums';
import { useEffect, useState } from 'react';
import { DropdownBaseV2 } from '../../../../theme/dropdowns/Dropdown';
import StarBorderIcon from '@mui/icons-material/StarBorder';
import StarIcon from '@mui/icons-material/Star';
import CloseIcon from '@mui/icons-material/Close';
import { useReportHubFilters } from '../../ReportHubFilterContext';
import ShSwitch from '../../../../theme/inputs/ShSwitch';

export const ReportFilterBooleanFilter = (props) => {
    const { t } = useTranslation();
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const filtersRegistry = useReportHubFilters();

    // resolve filter function
    const filter = filtersRegistry.filters[props.fKey];
    const resolvedFilter = typeof filter === "function" ? filter() : filter;

    // current boolean value
    const value = !!props.filter?.value;


    return (
        <Box
            // key={"rp"+idx}
            onClick={() => {
                props.setCurrentReport((prev) => ({
                    ...prev,
                    filter: {
                        ...prev?.filter,
                        [props.fKey]: {
                            ...prev?.filter?.[props.fKey],
                            value: [!value[0]], // toggle boolean
                        },
                    },
                }));
            }}
            className={cx(undefined,{
                "is-primary":props.filter.primary,
                "wrapped-filter":props.wrapFilters,
            })}
            sx={{
                px:0.5,
                pl:0.5,
                height:32,
                display:"flex",
                justifyContent:"flex-start",
                alignItems:'center',
                background:theme.palette.mode === "dark" ? colors.grey[600] : colors.grey[100],
                borderRadius:4,
                cursor:"pointer",
                    overflow:"hidden",
                "&.is-primary" : {
                    background:theme.palette.mode === "dark" ? colors.blue[100] : colors.primary[100],
                    border: `1px solid ${theme.palette.mode === "dark" ? colors.blue[400] : colors.primary[400]}`,
                },
                "&:hover .rp-value-container" : {
                    pr:4,
                },
                "&:hover .rp-value-container .rp-filter-icon" : {
                    zIndex:1,
                    opacity:1,
                        transition:"125ms",
                },
                "&.wrapped-filter" :{
                    width:1,
                }
            }}
        >

            
            <Box
                onClick={(e) => {
                    e.stopPropagation();

                    props.setCurrentReport((prev) => {
                        if (!prev?.filter) return prev;

                        const newFilters = {};

                        for (const key in prev.filter) {
                            // toggle primary for the clicked filter, unset for all others
                            newFilters[key] = {
                                ...prev.filter[key],
                                primary: key === props.fKey ? !prev.filter[key].primary : false,
                            };
                        }

                        return {
                            ...prev,
                            filter: newFilters,
                        };
                    });
                }}
                className={cx("rp-filter-icon", {
                    "is-primary": props.filter.primary,
                })}
                sx={{
                    mr:1,
                    display:'flex',
                    justifyContent:'center',
                    alignItems:'center',
                    flexShrink:0,
                    transition:"125ms",
                    height:24,
                    width:24,
                    background:theme.palette.mode === "dark" ? colors.grey[300] : colors.grey[0],
                    color:colors.txt['primary'],
                    borderRadius:4,
                    "&.is-primary": {
                        background:theme.palette.mode === "dark" ?colors.blue[400] : colors.primary[400],
                        color:theme.palette.mode === "dark" ? colors.txt["primaryDark"] : colors.txt["light"],
                    }
                }}
            >
                {props.filter.primary ?
                <StarIcon fontSize='small'/> : <StarBorderIcon fontSize='small'/>
                }
            </Box>

            <Text noBreak sx={{mr:2}}>
                {t(props.fKey)}
            </Text>
            <Box
                className={cx("rp-value-container",{
                    "is-primary":props.filter.primary,
                    "auto-align-right":props.wrapFilters,
                })}
                sx={{
                    position:"relative",
                    display:"flex",
                    alignItems:'center',
                    borderRadius:4,
                    color:colors.txt["primary"],
                    transition:"250ms",

                    background:colors.red[400],
                    color: theme.palette.mode === "dark" ? colors.txt["primaryDark"] : colors.txt["light"],
                    "&.auto-align-right" : {
                        ml:"auto",
                    }
                }}
            >
                <Box
                    sx={{
                        borderRadius:4,
                        px:1.5,
                        pr:0,
                        background:theme.palette.mode === "dark" ? props.filter.primary ? colors.grey[200] : colors.grey[400] : "#E9EFFE",
                    }}
                >
                    <ShSwitch
                        checked={value[0]}
                        onClick={(e) => e.stopPropagation()} // prevent row toggle
                        onChange={(e) => {
                            const checked = e.target.checked;
                            props.setCurrentReport((prev) => ({
                                ...prev,
                                filter: {
                                    ...prev?.filter,
                                    [props.fKey]: {
                                        ...prev?.filter?.[props.fKey],
                                        value: [checked],
                                    },
                                },
                            }));
                        }}
                        sx={{
                            transform: "scale(0.8)",
                        }}
                    />
                </Box>
                <Box
                    onClick={(e) => {
                        e.stopPropagation();

                        props.setCurrentReport((prev) => {
                            if (!prev?.filter) return prev;

                            const { [props.fKey]: _, ...remainingFilters } = prev.filter;

                            return {
                                ...prev,
                                filter: remainingFilters,
                            };
                        });
                    }}
                    className={cx("rp-filter-icon", {
                        "is-primary": props.filter.primary,
                        'showDelete':props.showDelete,
                    })}
                    sx={{
                        position:'absolute',
                        display:'flex',
                        alignItems:'center',
                        px:1,
                        pl:0.5,

                        right:"0px",
                        opacity:0,
                        transition:"125ms",
                        // transitionDelay:"125ms",

                        zIndex:-1,
                        "&.showDelete":{
                            position:"static",
                            opacity:1,
                            zIndex:2,
                        }
                        // "&.is-primary":{
                        //     right:"0px",
                        //     opacity:1,
                        //     zIndex:1,
                        // }
                    }}
                >
                    <CloseIcon fontSize="small"/>
                </Box>
            </Box>
        </Box>
    )
}